export const kNeighborArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy,",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "N-neighbors",
    type: "text",
    data: ["5"],
  },
  {
    name: "Weights",
    type: "dropdown",
    data: ["uniform", "distance"],
  },
  {
    name: "Algorithm",
    type: "dropdown",
    data: ["auto", "ball_tree", "kd_tree", "brute"],
  },
];

export const logisticRegressionArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "Dual",
    type: "dropdown",
    data: ["True", "False"],
  },
  {
    name: "C",
    type: "text",
    data: ["1.0"],
  },
  {
    name: "Random state",
    type: "dropdown",
    data: ["None", 0, 42],
  },
];

export const decisionTreeArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy,",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "Criterion",
    type: "dropdown",
    data: ["gini", "entropy"],
  },
  {
    name: "Splitter ",
    type: "dropdown",
    data: ["best", "random"],
  },
  {
    name: "Max depth",
    type: "text",
    data: [""],
  },
  {
    name: "Random state",
    type: "dropdown",
    data: ["None", 0, 42],
  },
];

export const randomForestArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy,",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "N-estimators",
    type: "text",
    data: ["100"],
  },
  {
    name: "Criterion",
    type: "dropdown",
    data: ["gini", "entropy"],
  },
  {
    name: "Max depth",
    type: "text",
    data: [""],
  },
  {
    name: "Random state",
    type: "dropdown",
    data: ["None", 0, 42],
  },
];

export const extraTreesArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy,",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "N-estimators",
    type: "text",
    data: ["100"],
  },
  {
    name: "Criterion",
    type: "dropdown",
    data: ["gini", "entropy"],
  },
  {
    name: "Max depth",
    type: "text",
    data: [""],
  },
  {
    name: "Random state",
    type: "dropdown",
    data: ["None", 0, 42],
  },
];

export const adaBoostArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy,",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "N-estimators",
    type: "text",
    data: ["100"],
  },
  {
    name: "Learning rate",
    type: "text",
    data: ["1"],
  },
  {
    name: "Algorithm",
    type: "dropdown",
    data: ["SAMME", "SAMME.R"],
  },
  {
    name: "Random state",
    type: "dropdown",
    data: ["None", 0, 42],
  },
];

export const supportVectorArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "chemotherapy",
      "hormone_therapy,",
      "inferred_menopausal_state",
      "overall_survival",
      "radiotherapy",
    ],
  },
  {
    name: "kernel",
    type: "dropdown",
    data: ["linear", "poly", "rbf", "sigmoid", "precomputed"],
  },
  {
    name: "Probability",
    type: "dropdown",
    data: ["True", "False"],
  },
  {
    name: "Tolerance",
    type: "text",
    data: ["1e-4"],
  },
  {
    name: "Random state",
    type: "dropdown",
    data: ["None", 0, 42],
  },
];
